import React, { useMemo } from 'react';
import { encodeCimDoc } from '@rendering/product-preview';
import { CanvasPreview } from '../../CanvasPreview';
export function FusionSceneServerFallbackPreview({ cimDoc, user, view, children, onError, onPaint }) {
    const cimDocUrl = useMemo(() => {
        return encodeCimDoc({ cimDoc });
    }, [cimDoc]);
    const renderOptions = useMemo(() => {
        return {
            format: 'png',
        };
    }, []);
    return (React.createElement(CanvasPreview, { cimDocUrl: cimDocUrl, user: user, view: view, children: children, onError: onError, onPaint: onPaint, renderOptions: renderOptions, throttleWaitMs: 300 }));
}
//# sourceMappingURL=FusionSceneServerFallbackPreview.js.map